function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "89.712%",
  y2: "95.911%",
  id: "search_circle_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#67DBC3",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2E648A",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "url(#search_circle_svg__a)",
  strokeWidth: 2,
  x: 1,
  y: 1,
  width: 46,
  height: 46,
  rx: 23
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.707 31.879l-4.37-4.37A9.932 9.932 0 0032 22c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10a9.932 9.932 0 005.509-1.663l4.369 4.37a.999.999 0 001.414 0l1.414-1.414a.999.999 0 00.001-1.414zM14 22c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8z",
  fill: "#41BCA3",
  fillRule: "nonzero"
}));

function SvgSearchCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDggNDgiPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSIwJSIgeTE9IjAlIiB4Mj0iODkuNzEyJSIgeTI9Ijk1LjkxMSUiIGlkPSJhIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzY3REJDMyIgb2Zmc2V0PSIwJSIgLz4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzJFNjQ4QSIgb2Zmc2V0PSIxMDAlIiAvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IHN0cm9rZT0idXJsKCNhKSIgc3Ryb2tlLXdpZHRoPSIyIiB4PSIxIiB5PSIxIiB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHJ4PSIyMyIgLz4KICAgICAgICA8cGF0aAogICAgICAgICAgICBkPSJNMzQuNzA3IDMxLjg3OWwtNC4zNy00LjM3QTkuOTMyIDkuOTMyIDAgMDAzMiAyMmMwLTUuNTE0LTQuNDg2LTEwLTEwLTEwcy0xMCA0LjQ4Ni0xMCAxMCA0LjQ4NiAxMCAxMCAxMGE5LjkzMiA5LjkzMiAwIDAwNS41MDktMS42NjNsNC4zNjkgNC4zN2EuOTk5Ljk5OSAwIDAwMS40MTQgMGwxLjQxNC0xLjQxNGEuOTk5Ljk5OSAwIDAwLjAwMS0xLjQxNHpNMTQgMjJjMC00LjQxMSAzLjU4OS04IDgtOHM4IDMuNTg5IDggOC0zLjU4OSA4LTggOC04LTMuNTg5LTgtOHoiCiAgICAgICAgICAgIGZpbGw9IiM0MUJDQTMiIGZpbGwtcnVsZT0ibm9uemVybyIgLz4KICAgIDwvZz4KPC9zdmc+";
export { SvgSearchCircle as ReactComponent };